import React from 'react';
import { ArrowRight, X } from 'lucide-react';
import { useWorkflow } from '../../contexts/WorkflowContext';

export const RiverButton = ({ label, icon, onClick, className = '' }) => (
  <button
    onClick={onClick}
    className={`group inline-flex items-center gap-2 px-5 py-2.5 rounded-lg font-semibold text-sm transition-all duration-200
      bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500
      text-white shadow-lg shadow-purple-500/25 hover:shadow-purple-500/40 hover:scale-[1.02] active:scale-[0.98]
      ${className}`}
    data-testid={`river-btn-${label.toLowerCase().replace(/\s+/g, '-')}`}
  >
    {icon && <span className="text-base">{icon}</span>}
    <span>{label}</span>
    <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
  </button>
);

export const RiverBanner = () => {
  const { workflow, clearRiver } = useWorkflow();

  if (!workflow.active) return null;

  const toolNames = {
    'generate': 'Content Generator',
    'hermes-forge': "Hermes' Forge",
    'apollo-chamber': "Apollo's Chamber",
    'trending': 'Trending Topics',
    'athena': 'Athena',
    'dionysus': 'Dionysus',
    'artemis': 'Artemis',
    'seo': 'SEO Optimizer',
    'multiply': 'Content Multiplier',
    'alliance': 'War Room',
  };

  const source = toolNames[workflow.sourceTool] || workflow.sourceTool || 'Unknown';

  return (
    <div className="mb-4 bg-gradient-to-r from-purple-900/40 to-indigo-900/40 border border-purple-500/30 rounded-xl px-5 py-3 flex items-center justify-between backdrop-blur-sm" data-testid="river-banner">
      <div className="flex items-center gap-3 text-sm">
        <span className="text-purple-400 font-bold tracking-wide uppercase text-xs">River Flow</span>
        <span className="text-gray-500">|</span>
        <span className="text-gray-300">
          Continuing from <span className="text-purple-300 font-semibold">{source}</span>
          {workflow.topic && (
            <> &mdash; <span className="text-white font-medium">"{workflow.topic.length > 60 ? workflow.topic.slice(0, 60) + '...' : workflow.topic}"</span></>
          )}
        </span>
      </div>
      <button onClick={clearRiver} className="text-gray-500 hover:text-white transition-colors p-1" data-testid="river-banner-dismiss">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
